import React from 'react';

const IconGmail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-github">
    <title>GitHub</title>
    <path d="M21.75 3.25H2.25A2.25 2.25 0 0 0 0 5.5v13.5a2.25 2.25 0 0 0 2.25 2.25h19.5a2.25 2.25 0 0 0 2.25-2.25V5.5a2.25 2.25 0 0 0-2.25-2.25zm0 2.25v.75l-9.75 6.75-9.75-6.75v-.75zm0 14.25H2.25V8.594l9.269 6.387a.75.75 0 0 0 .962 0L21.75 8.594z" />
  </svg>
);

export default IconGmail;
